export const validatePhoneNumber = (phoneNumber: string) => {
  // Phone number is optional
  if (!phoneNumber.length) {
    return true;
  }

  const unformattedPhoneNumber = phoneNumber.match(/\d/g);
  return unformattedPhoneNumber && unformattedPhoneNumber.length === 10;
};
